import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-signup-form',
    imports: [
        CommonModule
    ],
    templateUrl: './signup-form.component.html',
    styleUrl: './signup-form.component.scss'
})
export class SignupFormComponent implements OnInit {
  ngOnInit(): void {
    console.log('signup form initial load...');
    Breakpoint.init();
  }
}
